export default function () {
  return [
    {
      type: 'Input',
      title: '所在党支部名称',
      [$field]: 'orgName',
      readOnly: true,
      rules: ['']
    },
    {
      type: 'RemoteSelect',
      title: '困难级别',
      [$field]: 'poorLevel',
      readOnly: true,
      props: {
        url: 'api-general/module/portal/user/outGetList',
        map: {
          title: 'title',
          value: 'value'
        },
        params: {
          dictCode: 'GG57',
          merge: false,
          bizLineCode: this.bizLineCode || 'YWX01'
        }
      },
      rules: ['']
    },
    {
      type: 'Input',
      title: '所在工会组织名称',
      [$field]: 'ghName',
      readOnly: true,
      rules: ['']
    },
    {
      type: 'RemoteSelect',
      title: '困难级别',
      [$field]: 'poorLevel',
      readOnly: true,
      props: {
        url: 'api-general/module/portal/user/outGetList',
        map: {
          title: 'title',
          value: 'value'
        },
        params: {
          dictCode: 'GG57',
          merge: false,
          bizLineCode: this.bizLineCode || 'YWX01'
        }
      },
      rules: ['']
    }
  ]
}